import { computed } from 'vue';
import { LoadingStatuses } from '@/models/loading.interface'
import { IPresentableEntity } from '@/models/available-entities.interface';
import store from '@/store';

export default class OrganisationLinkingCode {

	public isLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusPrimaryData();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public isUnlinkOrganisationWarningActive = computed((): boolean => {
		return this.entitiesAffectedByUnlinking.value.length !== 0;
	});

	private entitiesAffectedByUnlinking = computed((): IPresentableEntity[] => {
		return store.getters.entitiesAffectedByUnlinking();
	});
}
